module.exports = __webpack_public_path__ + "img/triple-dot.f747b94b.svg";